import { useParams, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import BannerBlock from './BannerBlock/BannerBlock'
import ContentBlock from './ContentBlock/ContentBlock'
import GymBlock from './GymBlock/GymBlock'
import ExtraBlock from './ExtraBlock/ExtraBlock'
import MapBlock from './MapBlock/MapBlock'
import { fetchFacilityById } from '../../services/api'
import style from './unitpage.module.scss'

const UnitPage = () => {
    const { id } = useParams()
    const [facility, setFacility] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        const loadFacility = async () => {
            try {
                setLoading(true)
                const response = await fetchFacilityById(id)
                setFacility(response.data)
            } catch (err) {
                console.error('Error loading facility:', err)
            } finally {
                setLoading(false)
            }
        }

        if (id) {
            loadFacility()
        }
    }, [id])

    if (loading) {
        return (
            <div className={style.unitpage}>
                <div>Загрузка...</div>
            </div>
        )
    }

    if (error) {
        return (
            <div className={style.unitpage}>
                <div>{error}</div>
            </div>
        )
    }

    if (!facility) {
        return (
            <div className={style.unitpage}>
                <div>Филиал не найден</div>
            </div>
        )
    }

    return (
        <div className={style.unitpage}>
            <BannerBlock facility={facility} />
            <GymBlock facility={facility} />
            <ExtraBlock facility={facility} />
            <MapBlock facility={facility} />
        </div>
    )
}

export default UnitPage